import { createPortal } from 'react-dom';

interface Props {
    container: HTMLDivElement;
    children: any;
}

export const QueryResultsSearchPortal = (props: Props): JSX.Element => {
    return createPortal(props.children, props.container);
};
